<template>
    <span>Laravel ifixapp</span>
</template>

<script>
    export default {
        mounted() {
            // console.log('Component mounted.')
        }
    }
</script>
